import { Component, OnInit   } from '@angular/core';

import { ActivatedRoute } from '@angular/router';

import { FinanzasService } from 'app/finanzas/finanzas.service';

// Entidades
import { Bitacora, Query, Empresa } from 'app/finanzas/entidades';
import { operacion } from '../movimientos/movimientos.component';

import { MatDialog } from '@angular/material/dialog';

// Modales
import { FormGastos } from 'app/finanzas/modals/form-bitacora/gastos/form-gastos.component';
import { FormIngresos } from 'app/finanzas/modals/form-bitacora/ingresos/form-ingresos.component';
import { ConsultaFechaComponent } from 'app/finanzas/modals/consultaFecha/consultaFecha.component';

import Swal from 'sweetalert2';
import { prueba } from '../informe/informe.component';

@Component({
  selector: 'app-movimientosx-anio',
  templateUrl: './movimientosx-anio.component.html',
  styleUrls: ['./movimientosx-anio.component.css']
})
export class MovimientosxAnioComponent implements OnInit {


  // Variables  paginadores
  p1 : number = 1;
  p2 : number = 1;
  p3 : number = 1;
  p4 : number = 1;
  p5 : number = 1;
  p6 : number = 1;
  p7 : number = 1;
  p8 : number = 1;
  p9 : number = 1;
  p10: number = 1;
  p11: number = 1;
  p12: number = 1;
  pag1: number = 1;
  pag2: number = 1;
  pag3: number = 1;
  pag4: number = 1;
  pag5: number = 1;
  pag6: number = 1;
  pag7: number = 1;
  pag8: number = 1;
  pag9: number = 1;
  pag10: number = 1;
  pag11: number = 1;
  pag12: number = 1;

  

  movimiento: Bitacora = new Bitacora();

  gastos : any; 
  ingresos: any;

  f : any ;  // fecha 

  id_empresa: Number;
  nombre_empresa : string;

  anio: Number;
  diff : Number;

  diferenciaCE_MC : any ; 
  
  areas: any;
  puc: Object;

  valorGastos ;
  valorIngresos  ;

  constructor( 
          private service: FinanzasService, 
          private route:ActivatedRoute, 
          private dialog: MatDialog) {

      this.ingresos = [];
      this.gastos = [];
      this.valorGastos = [];
      this.valorIngresos = [];


      this.f = new Date();
  }
    
  ngOnInit()  {  
    this.route.queryParams
      .subscribe((params) => {
        this.id_empresa = params.empresa;
        this.anio = params.anio;
      })

    this.movimientos();  
    this.Empresa();
    this.tablaArea();
    this.tablaPuc();
    this.diferenciaCE();
    this.defValoresG();
    this.defValoresI();
    this.dataIngresosR();
    this.dataIngresosF();
    this.dataGastosR();
    this.dataGastosF();
    this.dataOperativaG();    
    this.dataAdministrativaG();    
    this.dataComercialG();    
    this.dataServiClientG();    
    this.dataTalentoG();

  }

  private movimientos() {
    this.service.filtro_anio(this.id_empresa, this.anio)
      .subscribe(( resp) => {   
        console.log(resp)     
        this.ingresos = resp.ingresos;
        this.gastos = resp.gastos
    }) 
  }
  private Empresa() {
    this.service.getEmpresaId(this.id_empresa)
      .subscribe(([resp]: Array<Empresa>) => {
        this.nombre_empresa = resp.Empresa; 
      })
  }

  private tablaArea(){
    this.service.getArea().subscribe( ( resp )  => {
      this.areas = resp;
    }) 
  }

  private tablaPuc() {
    this.service.getPuc(this.id_empresa).subscribe( ( resp) => {
      this.puc = resp  
    })
  }
  
  private diferenciaCE() {
    this.service.diferencia2(this.id_empresa, this.anio )
      .subscribe(  ( [resp]: Array<operacion> ) => {
        this.diferenciaCE_MC = resp.resultado  
      })
  }
  
  
  // servicio que trae los valores para la grafica (Ingresos)
  private defValoresI() {
    this.service.totalIMes(this.id_empresa, this.anio)
      .subscribe((resp: Array<prueba>) => {              
        for (const i of resp) {
          this.lineChartData[0].data.push(i.resultado)
      }
      
    })
  }
  
  
  //servicio que trae los valores para la grafica (Gastos)
  private defValoresG(){
    this.service.totalMesG(this.id_empresa, this.anio )
      .subscribe( (resp:Array<prueba> ) => {                
        for (const i of resp) {
          this.lineChartData[1].data.push(i.resultado)
      }
    })
  }

    // ingresos rutinarios
  private dataIngresosR(){
    this.service.ingresosR(this.id_empresa, this.anio)
      .subscribe(  ( resp:Array<prueba>  ) => {        
        for (const i of resp){
          this.DataIng[0].data.push(i.resultado)
        }
      })
  }

  // ingresos Fortuitos
  private dataIngresosF() {
    this.service.ingresosF(this.id_empresa, this.anio)
      .subscribe((resp: Array<prueba>) => {        
        for (const i of resp) {        
          this.DataIng[1].data.push(i.resultado)
        }
      })
  }

  private dataGastosR() {
    this.service.gastosR(this.id_empresa, this.anio)
      .subscribe((resp: Array<prueba>) => {        
        for (const i of resp) {
          this.Data[0].data.push(i.resultado)
        }
      })
  }
            // Datos para grafica gastos por area 
  private dataGastosF() {
    this.service.gastosF(this.id_empresa, this.anio)
      .subscribe((resp: Array<prueba>) => {        
        for (const i of resp) {
          this.Data[1].data.push(i.resultado)
        }
      })
  }

  private dataOperativaG() {
    this.service.operativaG(this.id_empresa, this.anio)
      .subscribe((resp: Array<prueba>) => {
        for (const i of resp) {
          this.dataArea[0].data.push(i.resultado)
        }
      })
  }

  private dataAdministrativaG() {
    this.service.administrativaG(this.id_empresa, this.anio)
      .subscribe((resp: Array<prueba>) => {
        for (const i of resp) {
          this.dataArea[1].data.push(i.resultado)
        }
      })
  }

  private dataComercialG() {
    this.service.comercialG(this.id_empresa, this.anio)
      .subscribe((resp: Array<prueba>) => {
        for (const i of resp) {
          this.dataArea[2].data.push(i.resultado)
        }
      })
  }

  private dataServiClientG() {
    this.service.serviClientG(this.id_empresa, this.anio)
      .subscribe((resp: Array<prueba>) => {
        for (const i of resp) {
          this.dataArea[3].data.push(i.resultado)
        }
      })
  }

  private dataTalentoG() {
    this.service.talentoG(this.id_empresa, this.anio)
      .subscribe((resp: Array<prueba>) => {
        for (const i of resp) {
          this.dataArea[4].data.push(i.resultado)
        }
      })
  }

  


  calcIngresos() {
    return this.valorIngresos.map(t => t.resultado).reduce((acc, value) => acc + value, 0);
  }

  calcGastos() {
    return this.valorGastos.map(t => t.resultado).reduce((acc, value) => acc + value, 0);
  }

  diferencia(  ){
    return this.calcIngresos() - this.calcGastos() 
  }
  
  // suma los ingresos del mes que se le pase
  totalMes_(mes) {
    var total: number = 0;
    let cont:number = 0;
    for (const i of this.valorIngresos) {
      cont +=1;
      if ( cont == mes ){
        total = i.resultado;
    }
  }
    return total 
}

  // suma de los gastos del mes obtenido
  totalMes(mes) {
    let total: number = 0;
    let cont : number = 0;

    for (const i of this.valorGastos) {
      cont += 1
      if( cont == mes ){
        total = i.resultado;
      }
    }    
    return total
  }


  verificar_mes() {
    let año_presente = this.f.getFullYear();
    if (this.anio < año_presente) {
      return true;
    }
    else if (this.anio == año_presente) {
      return true;
    }
    return false;
  }


  // modales
  AbrirModal(): void {
    const dialogRef = this.dialog.open(ConsultaFechaComponent, {
      width: '450px',
      data: {
        empresa: this.id_empresa,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.ngOnInit()
    });
  }

  form_bitacora_gastos(mes, id_gasto): void {
    const dialogRef = this.dialog.open(FormGastos, {
      width: '500px',
      data :{
        mes,
        id_gasto, 
        empresa: this.id_empresa,
        gastos: this.gastos,    
        areas:this.areas,
        puc: this.puc,
        anio: this.anio,
        mostrar: false, 
      }
    });

    dialogRef.afterClosed().subscribe(result => {      
      this.movimiento = result;
      console.log(this.movimiento)
      this.guardar();
    });
  }

  form_bitacora_ingresos(mes, id_gasto): void {
    const dialogRef = this.dialog.open(FormIngresos, {
      width: '500px',
      data :{
        mes,
        id_gasto, 
        empresa: this.id_empresa,
        ingresos: this.ingresos,    
        areas:this.areas,
        puc: this.puc,
        anio: this.anio,
        listM: false        
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.movimiento = result;   
      this.guardar();
    });
  }

  guardar() {
    // actualizar, editar 
    if (this.movimiento['id_gasto'] != undefined) {
      this.service.actualizarRegistro(this.movimiento, this.movimiento['id_gasto'])
        .subscribe((status: Query) => {
          const affectedRows = status.affectedRows
          // validacion con la respuesta de la bd
          if (affectedRows != 0) {
            Swal.fire({
              type: 'success',
              title: 'El registro fue actualizado'
            })

            this.movimientos()
            this.diferenciaCE();
            // vaciar las lista de la grafica
            this.lineChartData[0].data.length = 0   // lista de la grafica
            this.lineChartData[1].data.length = 0
            console.log(this.lineChartData[1].data.length = 0)
            // se llena de nuevo la lista de la grafica
            this.defValoresG();
            this.defValoresI();
            
          }
          else {
            Swal.fire({
              type: 'error',
              title: 'El registro no se pudo guardar',
            })
          }
          // 
              
              
          
        })
    }
    else {
      this.service.insertarRegistro(this.movimiento)
        .subscribe((status: Query) => {
          const id_insert = status.insertId;
          if (id_insert != 0) {
            Swal.fire({
              type: 'success',
              title: 'Registro Guardado',
            })
                this.movimientos();

                this.diferenciaCE();
                // vaciar la lista de la grafica
                this.lineChartData[0].data.length = [];
                this.lineChartData[1].data.length = [];
                // llena la lista de la grafica
                this.defValoresG();
                this.defValoresI();
  
          }
          else {
            Swal.fire({
              type: 'error',
              title: 'El registro no se pudo guardar',
            })
          }
        });
    }
  }


  eliminarRegistro( ingreso? , gasto? ){
    
    Swal.fire({
      title: '¿Esta seguro que desea eliminar este registro?',
      type: 'warning',
      showCancelButton:true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si'


    }).then((result) => {
      
      if (result.value) {
        if(ingreso){ this.movimiento = ingreso}
        if(gasto ){ this.movimiento = gasto}
        this.movimiento['estado'] = 0;
        this.service.borrarBitacora(this.movimiento, ingreso.id_gasto).subscribe( (resp:Query ) => {
          if( resp.affectedRows != 0  ){
            Swal.fire(
              'Eliminado',
              'El archivo fue eliminado correctamente',
              'success'
            )
              // trae los gastos y los ingresos
              this.movimientos();
              // realiza la resta entre gastos y comprobante 
              this.diferenciaCE();
              // vaciar la lista de la grafica
              this.lineChartData[0].data.length = [];
              this.lineChartData[1].data.length = [];
              this.Data[0].data.length = [];
              this.Data[1].data.length = [];
              this.DataIng[0].data.length = [];
              this.DataIng[1].data.length = [];
              // llenar los datos de la grafica 
              this.defValoresG();
              this.defValoresI();
          }
        })
      }
    })
  }



    // grafica gastos vs ingresos
  public lineChartData: Array<any> = [
    //  data:  lista que contiene la informacion( gastos, ingresos)   fill: background
    { data : [],  label: 'Ingresos', fill:false}, 
    { data: [], label: 'Gastos', fill:false },

  ];
  // labels
  public lineChartLabels: Array<any> = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre','Octubre', 'Noviembre', 'Diciembre'];

  public lineChartOptions: any = {
    responsive: false, 
    title:{
      display: true, 
      text: 'Ingresos vs Gastos ' 
    }, 

  };

  public lineChartColors: Array<any> = [''];

  public lineChartLegend: boolean = true;

  public lineChartType: string = 'line';


    // grafica  gastos fortuitos vs rutinarios

  public Data: Array<any> = [
    {data:[], label:'Rutinarios', fill: false }, 
    {data:[], label:'Fortuitos', fill:false }, 
  ];

  public Options: any = {
    responsive: false, 
    title:{
      display: true, 
      text: 'Rutinarios vs Fortuitos'
    }, 
  };

  // grafica  ingresos fortuitos vs rutinarios

  public DataIng: Array<any> = [
    { data: [], label: 'Rutinarios', fill: false },
    { data: [], label: 'Fortuitos', fill: false },
  ];

  // grafica area operativa

  public dataArea: Array<any> = [
    { data: [], label: 'Operativa', fill:false}, 
    { data: [], label: 'Administrativa', fill: false },  
    { data: [], label: 'Comercial', fill: false },  
    { data: [], label: 'Servicio al cliente', fill: false }, 
    { data: [], label: 'talento humano', fill: false } 
  ]

  public optionsArea: any = {
    responsive: false,
    title: {
      display: true,
      text: 'Gastos por area'
    },
  };

  

  
  

  

  
  
}
